import { useStatus } from 'src/components/status-store';
import React, { FC } from 'react';
import * as styles from './header.styles';

export interface LoggedInMenuProps {
  dropdownActive: boolean;
}

const LoggedInMenu: FC<LoggedInMenuProps> = ({ dropdownActive }) => {
  const { status } = useStatus();

  if (!dropdownActive) {
    return <></>;
  }

  return (
    <ul css={styles.memberDropdownList}>
      {(status?.roles?.indexOf('admin-view') || 0) > -1 && (
        <li css={styles.memberDropdownItem}>
          <a css={styles.memberDropdownItemLink} href="/admin/">
            Admin
          </a>
        </li>
      )}
      <li css={styles.memberDropdownItem}>
        <a css={styles.memberDropdownItemLink} href="/teams/">
          My Teams
        </a>
      </li>
      <li css={styles.memberDropdownItem}>
        <a
          css={styles.memberDropdownItemLink}
          href="https://accounts.domain.com.au/"
        >
          My Profile
        </a>
      </li>
      <li css={styles.memberDropdownItem}>
        <a
          css={[styles.memberDropdownItemLink, styles.textButton]}
          type="button"
          href="/account/signout"
        >
          Logout
        </a>
      </li>
    </ul>
  );
};

export default LoggedInMenu;
